import React from 'react';
import { EyeOutlined, DownOutlined, GlobalOutlined, HeartOutlined, UserAddOutlined, ShoppingOutlined, MobileOutlined } from '@ant-design/icons';
import { message } from 'antd';

const objectives = [
  {
    id: 'AWARENESS',
    icon: <EyeOutlined />,
    title: 'Awareness',
    description: 'Reach people who are most likely to remember your ads and increase brand recognition',
  },
  {
    id: 'TRAFFIC',
    icon: <GlobalOutlined />,
    title: 'Traffic',
    description: 'Drive traffic to your website or app to increase visits and engagement',
  },
  {
    id: 'ENGAGEMENT',
    icon: <HeartOutlined />,
    title: 'Engagement',
    description: 'Get more interactions, likes, shares, and comments on your content',
  },
  {
    id: 'LEADS',
    icon: <UserAddOutlined />,
    title: 'Leads',
    description: 'Generate high-quality leads and potential customers interested in your business',
  },
  {
    id: 'APP_PROMOTION',
    icon: <MobileOutlined />,
    title: 'App Promotion',
    description: 'Promote your mobile app to increase downloads and user acquisition',
  },
  {
    id: 'SALES',
    icon: <ShoppingOutlined />,
    title: 'Sales',
    description: 'Drive direct sales and conversions from your products or services',
  },
];

const ChooseCampaignObjective = ({ selectedObjective, onUpdate, onNext }) => {
  const handleSelect = (objectiveId) => {
    onUpdate(objectiveId);
  };

  const handleContinue = () => {
    if (!selectedObjective) {
      message.warning('Please select a campaign objective first');
      return;
    }
    onNext();
  };

  return (
    <div className="step-container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
      <h1 className="step-title" style={{ 
        fontSize: '32px', 
        fontWeight: 700, 
        color: '#000', 
        marginBottom: '12px',
        textAlign: 'center'
      }}>
        Choose Campaign Objective
      </h1>
      <p className="step-subtitle" style={{ 
        fontSize: '16px', 
        color: 'var(--ink-200)', 
        marginBottom: '24px',
        textAlign: 'center'
      }}>
        What do you want to achieve with this Meta campaign?
      </p>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(3, 1fr)', 
        gap: '16px', 
        marginBottom: '24px' 
      }}>
        {objectives.map((objective) => (
          <div
            key={objective.id}
            onClick={() => handleSelect(objective.id)}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '16px',
              padding: '24px',
              background: selectedObjective === objective.id ? '#f0f9ff' : '#fff',
              border: selectedObjective === objective.id ? '2px solid var(--ink)' : '1px solid var(--paper-300)',
              borderRadius: '12px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: selectedObjective === objective.id ? '0 4px 12px rgba(59, 130, 246, 0.15)' : '0 1px 3px rgba(0,0,0,0.1)',
            }}
            onMouseEnter={(e) => {
              if (selectedObjective !== objective.id) {
                e.currentTarget.style.borderColor = 'var(--paper-300)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.12)';
              }
            }}
            onMouseLeave={(e) => {
              if (selectedObjective !== objective.id) {
                e.currentTarget.style.borderColor = 'var(--paper-300)';
                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
              }
            }}
          >
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              background: selectedObjective === objective.id ? 'var(--ink)' : '#f3f4f6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '24px',
              color: selectedObjective === objective.id ? '#fff' : 'var(--ink-200)',
              flexShrink: 0,
            }}>
              {objective.icon}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ 
                fontSize: '18px', 
                fontWeight: 600, 
                color: '#111827',
                marginBottom: '6px'
              }}>
                {objective.title}
              </div>
              <p style={{ 
                fontSize: '14px', 
                color: 'var(--ink-200)',
                margin: 0,
                lineHeight: 1.5
              }}>
                {objective.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div style={{ 
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: '#fff',
        borderTop: '1px solid var(--paper-300)',
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'flex-end',
        zIndex: 10
      }}>
        <button 
          onClick={handleContinue}
          style={{
            padding: '12px 32px',
            background: selectedObjective ? 'var(--ink-200)' : 'var(--paper-300)',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '15px',
            fontWeight: 600,
            cursor: selectedObjective ? 'pointer' : 'not-allowed',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={(e) => {
            if (selectedObjective) {
              e.currentTarget.style.background = '#4b5563';
            }
          }}
          onMouseLeave={(e) => {
            if (selectedObjective) {
              e.currentTarget.style.background = 'var(--ink-200)';
            }
          }}
        >
          Continue
          <DownOutlined />
        </button>
      </div>
    </div>
  );
};

export default ChooseCampaignObjective;
